// Centralized API URL config with domain normalization
const raw = process.env.REACT_APP_BACKEND_URL || '';
// Normalize: booking.makspickleball.com → play.makspickleball.com
export const BACKEND_URL = raw.replace('booking.makspickleball.com', 'play.makspickleball.com');
export const API = BACKEND_URL ? `${BACKEND_URL}/api` : '/api';
